import React from 'react';
import { Modal } from 'anf-core-react';
import { useQuery } from '@apollo/client';
import SuccessContainer from './SuccessContainer';
import { ERROR_MESSAGE } from '../Messages/Messages';
import { SUCCESS_MODAL_FLAG_QUERY } from './operations';
import { SuccessModalPropTypes, SuccessModalDefaultProps } from './props';

export default function SuccessModal({ isOpen, onClose }) {
  const { data = {}, loading, error } = useQuery(SUCCESS_MODAL_FLAG_QUERY, {
    skip: !isOpen,
    ssr: false,
    context: { batch: true },
  });

  if (loading) return null;
  if (error) return ERROR_MESSAGE;

  const { isMFESuccessModalEnabled = false } = data;

  if (!isMFESuccessModalEnabled) return null;

  return (
    <Modal
      id="success-modal"
      isOpen={isOpen}
      onClose={onClose}
      variant="headerless"
    >
      <div className="scope-1892">
        <div className="success-modal" data-testid="success-modal">
          <SuccessContainer onClose={onClose} />
        </div>
      </div>
    </Modal>
  );
}

SuccessModal.propTypes = SuccessModalPropTypes;
SuccessModal.defaultProps = SuccessModalDefaultProps;
